import { Parameter$getCoordinateComments } from '~/api/gen'

export type Key = [
  operation: 'getCoordinateComments',
  params: Parameter$getCoordinateComments,
]

export const getCoordinateCommentsKey = (
  parameter: Parameter$getCoordinateComments
): Key => {
  return ['getCoordinateComments', parameter]
}
